import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import moment from 'moment';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function AddCheque() {
    const [errorMsg, seterrorMsg] = useState('');
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [cons, setCons] = useState([]);
    const [bankData, setBankData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [succesMsg, setsuccessMsg] = useState('');
    const [selectedBankType, setSelectedBankType] = useState('');
    const [currentBalance, setCurrentBalance] = useState('');
    const [registerFormData, setRegisterFormData] = useState({
        "che_date": '',
        "bank": '',
        "paid": '',
        "acc_head": '',
        "amount": '',
        "cheque": '',
        "memo": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]: event.target.value
        })
    };
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
        const acc_head = document.getElementById("acc_head").value;
        const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
        formData.append('bank', selectedBankType);
        formData.append('che_date', formattedDate);
        formData.append('paid', registerFormData.paid);
        formData.append('amount', registerFormData.amount);
        formData.append('acc_head', acc_head);
        formData.append('cheque', registerFormData.cheque);
        formData.append('memo', registerFormData.memo);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.post(baseUrl + 'add-cheque/', formData)
            .then((response) => {
                if (response.status == 200 || response.status == 201) {
                    const id = response.data.bank;
                    const amt = response.data.amount;
                    const bal = document.getElementById("bal").value;
                    const cbalance = parseFloat(bal) - parseFloat(amt);
                    const balanceFormData = new FormData();
                    balanceFormData.append('balance', cbalance);
                    balanceFormData.append('addedby', userName);
                    balanceFormData.append('ip_add', ipAddress);
                    balanceFormData.append('location', userLocation);
                    axios.put(baseUrl + 'update-bank/' + id + '/', balanceFormData)
                        .then((response1) => {
                            console.log(response1.data);
                            Swal.fire({
                                title: 'Deposit has been added.',
                                icon: 'success',
                                timer: 2000,
                                showConfirmButton: false
                            });
                        })
                        .catch(error => {
                            console.log(error);
                            Swal.fire(
                                'Error!',
                                'Failed to update bank balance. Please try again later.',
                                'error'
                            );
                        });
                    setTimeout(() => {
                        window.location.href = '/add-cheque/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to add deposit. Please try again later.',
                    'error'
                );
            });
    };
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        if (cons.length > 0) {
            setRows(cons);
        }
    }, [cons]);
    function fetchData() {
        setIsLoading(true);
        axios.get(`${baseUrl}add-cheque/`)
            .then(response => {
                setCons(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    useEffect(() => {
        fetchBankData();
    }, [selectedBankType]);
    function fetchBankData() {
        axios
            .get(`${baseUrl}add-bank/`)
            .then(response => {
                const bankData = response.data;
                setBankData(bankData);
                const selectedBank = bankData.find(bank => bank.id == selectedBankType);
                if (selectedBank) {
                    setCurrentBalance(selectedBank.balance);
                } else {
                    setCurrentBalance('');
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-cheque/' + id)
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    const columns = [
        {field: 'id', headerName: 'Id', width: 50},
        {field: 'che_date', headerName: 'Cheque Date', width: 100},
        {
            field: 'bank',
            headerName: 'Bank Name',
            width: 110,
            renderCell: (params) => {
                const bank = params.row.bank ? params.row.bank.bank : '';
                return <span>{bank}</span>;
            },
        },
        {field: 'paid', headerName: 'Paid To', width: 150},
        {field: 'acc_head', headerName: 'Account Head', width: 150},
        {field: 'amount', headerName: 'Amount', width: 100},
        {field: 'cheque', headerName: 'Ref No', width: 120},
        {field: 'memo', headerName: 'Memo', width: 160},
        {
            field: 'delete', headerName: 'Action',
            renderCell: (params) => (
                <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
                    <i className="fa-solid fa-trash-can"></i></button>
            ),
            width: 100
        },
    ];
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };
    const handleBankTypeChange = (event) => {
        const selectedBankTypeId = event.target.value;
        setSelectedBankType(selectedBankTypeId);
    };
    const buttonEnable = (registerFormData.consultant != '') && (registerFormData.specialization != '') && (registerFormData.mobile != '')
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-8 col-12">
                    <div className='card'>
                        <h4 className='card-header text-center'>Add Cheque</h4>
                        <div className='card-body'>
                            <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                            {succesMsg && <p className="text-success">{succesMsg}</p>}
                            {errorMsg && <p className="text-danger">{errorMsg}</p>}
                            <form>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="Deposit Time" className="form-label">Cheque Date : </label>
                                        <DatePicker className="form-control" name="che_date" id="che_date"
                                                    selected={selectedDate}
                                                    onChange={handleDateChange}
                                                    dateFormat="yyyy-MM-dd"
                                        />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="bank" className="form-label">Bank</label>
                                        <select
                                            className="form-control"
                                            value={selectedBankType}
                                            name="bank_id"
                                            id="bank_id"
                                            onChange={handleBankTypeChange}
                                        >
                                            <option>Select Bank</option>
                                            {bankData.map((bank) => (
                                                <option key={bank.id} value={bank.id}>
                                                    {bank.bank}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="balance" className="form-label">Current balance</label>
                                        <input type="text" className="form-control" name="bal" id="bal"
                                               value={currentBalance} readOnly/>
                                    </div>

                                </div>
                                <div className="row">

                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="paid" className="form-label">Paid To</label>
                                        <input type="text" maxLength={20} placeholder="Paid To" className="form-control"
                                               name="paid" value={registerFormData.paid} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Cheque No" className="form-label">Cheque No</label>
                                        <input type="text" maxLength={20} placeholder="Cheque No"
                                               className="form-control"
                                               name="cheque" value={registerFormData.cheque} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="acc_head" className="form-label">Account Head</label>
                                        <select className="form-control" value={registerFormData.acc_head}
                                                onChange={inputHandler}
                                                name="acc_head" id="acc_head">
                                            <option>Select</option>
                                            <option value="Accounts Payable">Accounts Payable - Liability</option>
                                            <option value="Accounts Receivable">Accounts Receivable -</option>
                                            <option value="Cash">Cash - Non Current</option>
                                            <option value="Cash-in-Bank">Cash-in-Bank - Current</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Account No" className="form-label">Amount</label>
                                        <input type="text" maxLength={20} placeholder="Amount" className="form-control"
                                               name="amount" value={registerFormData.amount} onChange={inputHandler}/>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Memo" className="form-label">Memo</label>
                                        <input type="text" maxLength={20} placeholder="Memo" className="form-control"
                                               name="memo" value={registerFormData.memo} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button type="button" disabled={!buttonEnable} onClick={submitHandler}
                                                className="btn btn-success">Register
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{height: "100%", width: "100%"}}>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}
                          pageSize={28}
                          rows={rows}
                          columns={columns}
                          components={{
                              Toolbar: GridToolbar,
                          }}
                          autoHeight
                />
            </div>
        </section>
    );
}
export default AddCheque;
